<script setup lang="ts">
import { computed } from 'vue'
import type { CustomRmiLink } from '../../api/tecdocApi'
import { getIcon } from './shortcutIcons'

const props = defineProps<{
  link: CustomRmiLink
  editable?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'remove'): void
}>()

const iconDef = computed(() => getIcon(props.link.iconCode))

function onCardClick() {
  emit('click')
}

function onRemoveClick(e: Event) {
  e.stopPropagation()
  emit('remove')
}
</script>

<template>
  <button
    type="button"
    class="shortcut-card"
    :title="`Kategori-ID: ${link.categoryId}`"
    @click="onCardClick"
  >
    <span class="shortcut-card__icon">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        v-html="iconDef.svgPath"
      />
    </span>
    <span class="shortcut-card__label">{{ link.label }}</span>
    <button
      v-if="editable"
      type="button"
      class="shortcut-card__remove"
      title="Fjern"
      @click="onRemoveClick"
    >
      ×
    </button>
  </button>
</template>

<style scoped lang="scss">
.shortcut-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  width: 100%;
  min-height: 96px;
  padding: 0.75rem 0.5rem 0.625rem;
  background: #e0ecff;
  color: #002868;
  border: 1px solid #002868;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, transform 0.1s;
  text-align: center;

  &:hover {
    background: #c7dcff;
    border-width: 2px;
    padding: calc(0.75rem - 1px) calc(0.5rem - 1px) calc(0.625rem - 1px);
  }

  &:active {
    transform: translateY(1px);
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__label {
    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1.2;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }

  &__remove {
    position: absolute;
    top: 3px;
    right: 3px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    background: transparent;
    border: none;
    color: #991b1b;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    border-radius: 50%;

    &:hover {
      background: #fee2e2;
    }
  }
}
</style>
